import SEOHead from '@/components/SEOHead';
import Navigation from '@/components/Navigation';
import ServicesSection from '@/components/ServicesSection';
import PortfolioSection from '@/components/PortfolioSection';
import ProcessSection from '@/components/ProcessSection';
import Footer from '@/components/Footer';
import CookieConsent from '@/components/CookieConsent';
import BackToTop from '@/components/BackToTop';

export default function ServicesPage() {

  return (
    <div className="min-h-screen bg-white dark:bg-[#0A0A0A] transition-colors duration-300">
      <SEOHead
        title="Web Design Services Bournemouth | What We Do | UI Designs"
        description="Custom website design, managed hosting, and ongoing care for small businesses. Affordable web design in Bournemouth, Poole, and Christchurch — built, hosted, and maintained for you."
        canonical="https://uidesigns.co.uk/services"
        keywords="web design services Bournemouth, website design, landing pages, small business website packages"
      />
      <Navigation />
      <main className="pt-20">
        <ServicesSection />
        <PortfolioSection />
        <ProcessSection />
      </main>
      <Footer />
      <CookieConsent />
      <BackToTop />
    </div>
  );
}
